import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import appointmentsLogo from "assets/appointment-icon-big.png";
import { Link } from "react-router-dom";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import { StatusCircle } from "components/helpers";
import {
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },

  appointmentCount: {
    color: "#cc3366",
  },
  aptLogo: {
    width: 30,
    height: 20,
    margin: "0px 5px 5px 0px",
  },
  listItem: {
    //paddingBottom: 15
  },
  link: {
    "&:hover": {
      textDecoration: "none",
    },
  },
  divider: {
    margin: "6px 0px",
  },
}));

// function generate(element) {
//   return [0, 1, 2, 4].map((value) =>
//     React.cloneElement(element, {
//       key: value,
//     }),
//   );
// }

const TodaysAppointmentList = ({ count }) => {
  const classes = useStyles();
  // const [dense, setDense] = React.useState(false);
  // eslint-disable-next-line
  const [secondary, setSecondary] = useState(false);

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <span style={{ fontSize: "15px", fontWeight: 401, color: "#333" }}>
            <img src={appointmentsLogo} alt="" className={classes.aptLogo} />{" "}
            APPOINTMENTS
          </span>
          <Card style={{ marginTop: "5px", borderRadius: 10 }}>
            <CardContent>
              <List dense={false}>
                <>
                  <ListItem className={classes.listItem}>
                    <StatusCircle offlineType={true} />
                    <ListItemText
                      primary="OFF LINE"
                      secondary={secondary ? "Secondary text" : null}
                    />
                    <ListItemSecondaryAction>
                      <IconButton edge="end" aria-label="delete">
                        <Typography
                          variant="h4"
                          component="h4"
                          className={classes.appointmentCount}
                        >
                          {count?.todaysDateCount?.offlineCountForToday || 0}
                        </Typography>
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider className={classes.divider} />
                  <ListItem className={classes.listItem}>
                    <StatusCircle status="confirmed" />
                    <ListItemText
                      primary="CONFIRMED"
                      secondary={secondary ? "Secondary text" : null}
                    />
                    <ListItemSecondaryAction>
                      <IconButton edge="end" aria-label="delete">
                        <Typography
                          variant="h4"
                          component="h4"
                          className={classes.appointmentCount}
                        >
                          {count?.todaysDateCount?.confirmedCountForToday || 0}
                        </Typography>
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider className={classes.divider} />
                  <ListItem className={classes.listItem}>
                    <StatusCircle status="waiting" />
                    <ListItemText
                      primary="WAITING LIST"
                      secondary={secondary ? "Secondary text" : null}
                    />
                    <ListItemSecondaryAction>
                      <IconButton edge="end" aria-label="delete">
                        <Typography
                          variant="h4"
                          component="h4"
                          className={classes.appointmentCount}
                        >
                          {count?.todaysDateCount?.waitingListCountForToday ||
                            0}
                        </Typography>
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider className={classes.divider} />
                  <ListItem className={classes.listItem}>
                    <StatusCircle status="cancellationrequest" />
                    <ListItemText
                      primary="CANCELLATION"
                      secondary={secondary ? "Secondary text" : null}
                    />
                    <ListItemSecondaryAction>
                      <IconButton edge="end" aria-label="delete">
                        <Typography
                          variant="h4"
                          component="h4"
                          className={classes.appointmentCount}
                        >
                          {count?.todaysDateCount?.cancellationCountForToday ||
                            0}
                        </Typography>
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                </>
                ,
              </List>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span
              style={{ fontSize: "14px", fontWeight: "bold", color: "black" }}
            >
              <AssignmentTurnedInOutlinedIcon variant="outline" /> E-CHECK IN
            </span>
            <Link to="/appointments" className={classes.link}>
              <span
                style={{
                  marginLeft: "15px",
                  color: "#cc3366",
                  fontWeight: "bold",
                }}
              >
                {" "}
                View List
              </span>
            </Link>
          </div>
          <Card style={{ marginTop: "5px" }}>
            <CardContent>
              <Typography color="subtitle1">No Apponitment Found</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default TodaysAppointmentList;
